module.exports = __webpack_public_path__ + "1f5d71e5831618be77d21acf5b7865c4.MP3";